import { api } from '../http';

export const getAuctionClarifications = auctionId =>
  api.get(`/auctions/${auctionId}/clarifications`);
export const createAuctionClarification = (auctionId, data) =>
  api.post(`/auctions/${auctionId}/clarifications`, data);
export const answerAuctionClarification = (auctionId, clarificationId, data) =>
  api.patch(`/auctions/${auctionId}/clarifications/${clarificationId}`, data);
